import {
  cacheKeys,
  Media,
  Product,
  useUpdateMutation,
} from '@gripp/shared-logic';
import { CustomAlert } from '@gripp/shared-ui';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

type DeleteProductFileModalProps = {
  visible: boolean;
  hide: () => void;
  media: Media;
  product: Product;
  onDelete: () => void;
};

export const DeleteProductFileModal = (props: DeleteProductFileModalProps) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { mutateAsync: updateProduct } = useUpdateMutation({
    modelName: 'product',
    query: UPDATE_PRODUCT,
  });

  const doDelete = async () => {
    const fileList =
      props.product.media
        ?.filter((file) => file.id !== props.media.id)
        .map((f) => ({ id: f.id })) || [];

    const input = {
      id: props.product.id,
      media: fileList,
    };
    await updateProduct(
      { input },
      {
        onSuccess: async () => {
          const cacheKey = cacheKeys('product').all;
          await queryClient.invalidateQueries({ queryKey: cacheKey });
          props.onDelete();
        },
      }
    );
    props.onDelete();
  };

  return (
    <CustomAlert
      visible={props.visible}
      hideAlert={props.hide}
      action={doDelete}
      title={t('product.detail.confirmDelete', { fileName: props.media.name })}
      primaryButtonLabel={t('topNav.customAlert.yes')}
      secondaryButtonLabel={t('topNav.customAlert.cancel')}
    />
  );
};

const UPDATE_PRODUCT = `
  mutation Mutation($input: MutateProductInput!) {
  updateProduct(input: $input) {
    id
  }
}
`;

const styles = StyleSheet.create({});
